import React, { useEffect, useState } from "react";
import axiosInstance from "../../api/axiosInstance";
import Swal from "sweetalert2";
import { jsPDF } from "jspdf";
import autoTable from "jspdf-autotable";
import pdfImg from "../../assests/form-bg.jpg";
import originalMedical from "../../assests/originalMedical.png";
import logo from "../../assests/Image.jpg";
import pdfimg3 from "../../assests/pdfimg3.png";
import logo1 from "../../assests/logo.png";
import pdfHealth from "../../assests/pdfHealth.jpg";
import pdfHouse from "../../assests/pdfHouse.jpg";
import { tajawalFontBase64 } from "../../assests/font/tajawalFont";
import { baseurImage } from "../../Baseurl";

export default function PortalForms({ patientId }) {
    const [forms, setForms] = useState([]);
    const [loading, setLoading] = useState(true);
    const [patientData, setPatientData] = useState(null);
    const [currentPage, setCurrentPage] = useState(1);
    const formsPerPage = 10;

    const [businessLogo, setBusinessLogo] = useState(logo1);
    const [businessOfficialName, setBusinessOfficialName] = useState(
        "Serenity Medical Center"
    );
    const [businessOfficialNameArabic, setBusinessOfficialNameArabic] = useState(
        "مركز سيرينيتي الطبي"
    );
    const [businessEmail, setBusinessEmail] = useState("");
    const [businessAddress, setBusinessAddress] = useState("");
    const [businessPhone, setBusinessPhone] = useState("");

    // Helper function to extract date from datetime string
    const extractDateFromDateTime = (dateTimeString) => {
        if (!dateTimeString) return "";
        return dateTimeString.split("T")[0].split(" ")[0];
    };

    // Load business logo and name from localStorage on component mount
    useEffect(() => {
        const loadFromLocalStorage = async () => {
            // Load official name
            const savedSetting = JSON.parse(localStorage.getItem("businessSetting"));
            const storedOfficialName = savedSetting?.official_name?.trim() || "";
            const storedOfficialNameArabic =
                savedSetting?.official_name_arabic?.trim() || "";
            const storedEmail = savedSetting?.email || "";
            const storedPhone = savedSetting?.telephone_1 || "";
            const storedAddress = savedSetting?.address || "";

            if (storedOfficialName) setBusinessOfficialName(storedOfficialName);
            if (storedOfficialNameArabic) setBusinessOfficialNameArabic(storedOfficialNameArabic);
            if (storedEmail) setBusinessEmail(storedEmail);
            if (storedPhone) setBusinessPhone(storedPhone);
            if (storedAddress) setBusinessAddress(storedAddress);

            // Load logo
            const storedLogo = savedSetting?.base64Image;
            if (storedLogo) {
                if (storedLogo.startsWith("data:image/") && storedLogo.includes("base64")) {
                    setBusinessLogo(storedLogo);
                } else {
                    try {
                        const imageUrl = `${baseurImage}business_setting/${storedLogo}`;
                        const response = await fetch(imageUrl);
                        const contentType = response.headers.get("content-type");
                        if (contentType && contentType.startsWith("image/")) {
                            const blob = await response.blob();
                            const reader = new FileReader();
                            reader.onloadend = () => {
                                setBusinessLogo(reader.result);
                            };
                            reader.readAsDataURL(blob);
                        }
                    } catch (err) {
                        console.warn("Failed to load logo:", err);
                    }
                }
            }
        };

        loadFromLocalStorage();
    }, []);

    useEffect(() => {
        const fetchPatientData = async () => {
            try {
                const response = await axiosInstance.get(`getPatientById/${patientId}`);
                if (response.data?.success && response.data?.data) {
                    setPatientData(response.data.data);
                }
            } catch (error) {
                console.error("Error fetching patient data:", error);
            }
        };

        if (patientId) {
            fetchPatientData();
        }
    }, [patientId]);

    useEffect(() => {
        const fetchAllForms = async () => {
            if (!patientId) return;

            let allForms = [];

            try {
                // Fetch AMA forms
                try {
                    const acknowledgementResponse = await axiosInstance.get(
                        `getAcknowledgementByPatientId/${patientId}`
                    );

                    const responseData =
                        acknowledgementResponse.data?.data || acknowledgementResponse.data;

                    if (
                        responseData &&
                        Array.isArray(responseData) &&
                        responseData.length > 0
                    ) {
                        const amaForms = responseData.map((ack, index) => {
                            const uniqueId = ack.created_at
                                ? new Date(ack.created_at).getTime()
                                : Date.now() + index;
                            return {
                                id: uniqueId,
                                type: "ama",
                                data: {
                                    patientName:
                                        ack.patientName ||
                                        `${patientData?.firstName || ""} ${patientData?.lastName || ""
                                            }`.trim(),
                                    fileNo:
                                        ack.fileNumber ||
                                        patientData?.fileNumber ||
                                        patientData?.id ||
                                        "",
                                    date: ack.created_at
                                        ? extractDateFromDateTime(ack.created_at)
                                        : "",
                                    cprNo:
                                        ack.civilIdNumber ||
                                        patientData?.civilIdNumber ||
                                        patientData?.cpr ||
                                        "",
                                    physician:
                                        ack.doctorName || patientData?.Primary_Doctor || "",
                                    ageSex: `${ack.age || patientData?.age || ""}/${ack.gender || patientData?.gender || ""
                                        }`,
                                    recommendation: ack.physical_recommendation || "",
                                    patientSignature: ack.patient_signature || "",
                                    patientSignatureDate: ack.patient_date
                                        ? ack.patient_date.split("T")[0]
                                        : "",
                                    witnessName: ack.witness_name || "",
                                    witnessSignature: ack.witness_signature || "",
                                    witnessSignatureDate: ack.witness_date
                                        ? ack.witness_date.split("T")[0]
                                        : "",
                                },
                                createdAt: ack.created_at || new Date().toISOString(),
                                apiId: uniqueId,
                                dbId: ack.acknowledgement_form_id || ack.id,
                            };
                        });
                        allForms = [...allForms, ...amaForms];
                    }
                } catch (ackError) {
                    console.error("Error fetching acknowledgement forms:", ackError);
                }

                // Fetch medical certificates
                try {
                    const medicalCertResponse = await axiosInstance.get(
                        `getMedicalCertificateDetailsByPatientId/${patientId}`
                    );

                    const responseData =
                        medicalCertResponse.data?.data || medicalCertResponse.data;
                    const certData = responseData?.medical_certificates || responseData;
                    const patientInfo = responseData?.patient || patientData;
                    const diagnosisInfo = responseData?.diagnosis || [];

                    if (certData && Array.isArray(certData) && certData.length > 0) {
                        const medicalCertForms = certData.map((cert, index) => {
                            const uniqueId = cert.created_at
                                ? new Date(cert.created_at).getTime()
                                : Date.now() + index + 10000;

                            return {
                                id: uniqueId,
                                type: (cert.accompanying_patient === 1 || cert.accompanying_patient === true) ? "accompanyingCertificate" : "medicalCertificate",
                                data: {
                                    patientName: `${patientInfo?.firstName || ""} ${patientInfo?.lastName || ""
                                        }`.trim(),
                                    cprNumber: cert.cpr_number || patientInfo?.civilIdNumber || "",
                                    medicalRecordNumber:
                                        cert.medical_record_number ||
                                        patientInfo?.fileNumber ||
                                        patientInfo?.id ||
                                        "",
                                    reportedSick:
                                        cert.reported_sick === 1 || cert.reported_sick === true,
                                    accompanyingPatient:
                                        cert.accompanying_patient === 1 ||
                                        cert.accompanying_patient === true,
                                    accompanyingPersonName: cert.accompany_name || "",
                                    accompanyingPersonId: cert.accompany_id || "",
                                    timeOfAttend: cert.time_of_attend || "",
                                    timeOfConsult: cert.time_of_consult || "",
                                    consultDate: cert.consult_date
                                        ? cert.consult_date.split("T")[0]
                                        : "",
                                    patientFitForDuty:
                                        cert.patient_fit_for_duty === 1 ||
                                        cert.patient_fit_for_duty === true,
                                    patientUnfitForDuty:
                                        cert.patient_unfit_for_duty === 1 ||
                                        cert.patient_unfit_for_duty === true,
                                    advisedLightDuty:
                                        cert.advised_light_duty === 1 ||
                                        cert.advised_light_duty === true,
                                    patientNeedsEmployeeCare:
                                        cert.patient_needs_employee_care === 1 ||
                                        cert.patient_needs_employee_care === true,
                                    noOfDaysOffFigures:
                                        cert.no_of_days_off_figures?.toString() || "",
                                    noOfDaysOffWords: cert.no_of_days_off_words || "",
                                    commencingOn: cert.commencing_on
                                        ? cert.commencing_on.split("T")[0]
                                        : "",
                                    admittedOn: cert.admitted_on
                                        ? cert.admitted_on.split("T")[0]
                                        : "",
                                    dischargedOn: cert.discharged_on
                                        ? cert.discharged_on.split("T")[0]
                                        : "",
                                    diagnosis: (() => {
                                        const matchingDiagnosis = Array.isArray(diagnosisInfo)
                                            ? diagnosisInfo.find(
                                                (d) =>
                                                    d.medical_certificate_id ===
                                                    (cert.certificate_id || cert.id)
                                            )
                                            : null;
                                        return matchingDiagnosis
                                            ? matchingDiagnosis.diagnosis_text
                                            : cert.diagnosis || "";
                                    })(),
                                    diagnosisId: (() => {
                                        const matchingDiagnosis = Array.isArray(diagnosisInfo)
                                            ? diagnosisInfo.find(
                                                (d) =>
                                                    d.medical_certificate_id ===
                                                    (cert.certificate_id || cert.id)
                                            )
                                            : null;
                                        return matchingDiagnosis
                                            ? matchingDiagnosis.id || matchingDiagnosis.code
                                            : cert.diagnosis_id || "";
                                    })(),
                                    doctorName: patientInfo?.doctorName || cert.doctor_name || "",
                                    licenseNo: patientInfo?.licenseId || cert.license_no || "",
                                    specialty: patientInfo?.specialty || cert.specialty || "",
                                    issueDate: cert.issue_date
                                        ? cert.issue_date.split("T")[0]
                                        : cert.created_at
                                            ? cert.created_at.split("T")[0]
                                            : "",
                                    certificateRegistrationNo:
                                        cert.certificate_registration_no || "",
                                    facilityContactAddress: cert.facility_contact_address || "",
                                },
                                createdAt: cert.created_at || new Date().toISOString(),
                                apiId: uniqueId,
                                dbId: cert.certificate_id || cert.id,
                            };
                        });
                        allForms = [...allForms, ...medicalCertForms];
                    }
                } catch (certError) {
                    console.error("Error fetching medical certificates:", certError);
                }

                // Fetch referral forms
                try {
                    const referralResponse = await axiosInstance.get(
                        `getReferralDetailsByPatientId/${patientId}`
                    );

                    const referralData =
                        referralResponse.data?.data || referralResponse.data;

                    if (
                        referralData &&
                        Array.isArray(referralData) &&
                        referralData.length > 0
                    ) {
                        const referralForms = referralData.map((ref, index) => {
                            const uniqueId = ref.created_at
                                ? new Date(ref.created_at).getTime()
                                : Date.now() + index + 20000;

                            return {
                                id: uniqueId,
                                type: "referral",
                                data: {
                                    patientName: `${ref.firstName || ""} ${ref.lastName || ""
                                        }`.trim(),
                                    cpr: ref.cpr_number || ref.civilIdNumber || "",
                                    age: ref.age?.toString() || "",
                                    sex: ref.gender || "",
                                    nationality: ref.nationality || "",
                                    mobileNumber: ref.mobileNumber || "",
                                    referralType: ref.referral_type || "",
                                    referralCategory: ref.referral_category || "",
                                    reasonOfReferral: ref.reason_of_referral || "",
                                    chiefComplain: ref.chief_complaint || "",
                                    summaryOfPresentation: ref.summary_presentation || "",
                                    vitalSigns: {
                                        bp: ref.blood_pressure || "",
                                        respiratoryRate: ref.respiratory_rate || "",
                                        pulse: ref.pulse || "",
                                        spo2: ref.spo2 || "",
                                        rbs: ref.rbs_mg || ref.rbs || ref.random_blood_sugar || "",
                                        temperature: ref.temperature || ref.vitals?.toString() || "",
                                        weight: ref.weight || "",
                                    },
                                    glasgowComaScale: {
                                        eye: ref.gcs_eye || "",
                                        motorResponse: ref.gcs_motor_response || "",
                                        verbalResponse: ref.gcs_verbal_response || "",
                                        totalScore: ref.gcs_total_score?.toString() || "",
                                    },
                                    generalExamination: ref.general_examination || "",
                                    localExamination: ref.local_examination || "",
                                    investigationsDone: ref.investigations_done || "",
                                    procedureInterventions: ref.procedures_and_interventions || "",
                                    injectionsMedications: ref.injections_and_medications || "",
                                    prescriptionGiven: ref.prescription_given || "",
                                    notes: ref.notes || ref.note || "",
                                    advices: ref.advices || "",
                                    referringDoctor: {
                                        name: ref.referring_doctor_name || "",
                                        date:
                                            ref.referring_doctor_date &&
                                                ref.referring_doctor_date !== "0000-00-00"
                                                ? ref.referring_doctor_date.split("T")[0]
                                                : "",
                                        time: ref.referring_doctor_time || "",
                                        phoneNumber: ref.referring_doctor_phone || "",
                                    },
                                    receivingDoctor: {
                                        name: ref.receiving_doctor_name || "",
                                        date:
                                            ref.receiving_doctor_date &&
                                                ref.receiving_doctor_date !== "0000-00-00"
                                                ? ref.receiving_doctor_date.split("T")[0]
                                                : "",
                                        time:
                                            ref.receiving_doctor_time &&
                                                ref.receiving_doctor_time !== "00:00:00"
                                                ? ref.receiving_doctor_time
                                                : "",
                                        phoneNumber: ref.receiving_doctor_phone || "",
                                    },
                                },
                                createdAt: ref.created_at || new Date().toISOString(),
                                apiId: uniqueId,
                                dbId: ref.referral_form_id || ref.id,
                            };
                        });
                        allForms = [...allForms, ...referralForms];
                    }
                } catch (refError) {
                    console.error("Error fetching referral forms:", refError);
                }

                // Fetch Health Fitness Certs
                try {
                    const hfResponse = await axiosInstance.get(`getHealthFitnessByPatientId/${patientId}`);
                    const hfData = hfResponse.data?.data || hfResponse.data;
                    if (hfData && Array.isArray(hfData) && hfData.length > 0) {
                        const hfForms = hfData.map((hf, index) => ({
                            id: `hf-${hf.id || index}`,
                            type: "healthFitnessCertificate",
                            data: {
                                name: hf.name || "",
                                cprNumber: hf.cpr_number || "",
                                profession: hf.profession || "",
                                performedByName: hf.performed_by_name || "",
                                licenseNumber: hf.license_number || "",
                                category: hf.category || "",
                                examinationDate: hf.examination_date || "",
                                hiv1Hiv2: hf.hiv1_hiv2 || "",
                                hbsag: hf.hbsag || "",
                                hcv: hf.hcv || "",
                                bloodPressure: hf.blood_pressure || "",
                                randomBloodSugar: hf.random_blood_sugar || "",
                                ppdReading: hf.ppd_reading || "",
                                igra: hf.igra || "",
                                chestXray: hf.chest_xray || "",
                                physicalGeneral: hf.physical_general || "",
                                physicalChest: hf.physical_chest || "",
                                physicalHeart: hf.physical_heart || "",
                                physicalAbdomen: hf.physical_abdomen || "",
                                physicalOthers: hf.physical_others || "",
                                referral: hf.referral || "",
                                vaccinationComments: hf.vaccination_comments || "",
                                healthDeclaration: hf.health_declaration === 1,
                                certificateDeclaration: hf.certificate_declaration === 1
                            },
                            createdAt: hf.created_at || new Date().toISOString()
                        }));
                        allForms = [...allForms, ...hfForms];
                    }
                } catch (hfErr) {
                    console.error("Error fetching health fitness forms:", hfErr);
                }

                // Fetch Housemaid Health Checkup
                try {
                    const hmResponse = await axiosInstance.get(`getHousemaidHealthCheckupByPatientId/${patientId}`);
                    const hmData = hmResponse.data?.data || hmResponse.data;
                    if (hmData && Array.isArray(hmData) && hmData.length > 0) {
                        const hmForms = hmData.map((hm, index) => ({
                            id: `hm-${hm.id || index}`,
                            type: "houseMaidHealthCheckup",
                            data: {
                                patientName: hm.patient_name || "",
                                civilId: hm.civil_id || "",
                                mobileNumber: hm.mobile_number || "",
                                height: hm.height || "",
                                doctorName: hm.doctor_name || "",
                                examinerLicense: hm.examiner_license || "",
                                bloodPressure: hm.blood_pressure || "",
                                pulse: hm.pulse || "",
                                heightCm: hm.height_cm || "",
                                weight: hm.weight || "",
                                bmi: hm.bmi || "",
                                albumin: hm.albumin || "",
                                blood: hm.blood || "",
                                urineComments: hm.urine_comments || "",
                                rightEyeReadings: hm.right_eye_readings || "",
                                rightEyeStatus: hm.right_eye_status || "",
                                leftEyeReadings: hm.left_eye_readings || "",
                                leftEyeStatus: hm.left_eye_status || "",
                                colorVisionReadings: hm.color_vision_readings || "",
                                colorVisionStatus: hm.color_vision_status || "",
                                eyeComment: hm.eye_comment || ""
                            },
                            createdAt: hm.created_at || new Date().toISOString()
                        }));
                        allForms = [...allForms, ...hmForms];
                    }
                } catch (hmErr) {
                    console.error("Error fetching housemaid forms:", hmErr);
                }

                setForms(allForms);
            } catch (error) {
                console.error("Error fetching forms:", error);
            } finally {
                setLoading(false);
            }
        };

        if (patientId) {
            fetchAllForms();
        }
    }, [patientId, patientData]);

    // PDF Generation Functions
    const generateForm = (form) => {
        if (!form || !form.data) {
            Swal.fire({
                icon: "error",
                title: "Error",
                text: "No form data available to generate PDF.",
            });
            return;
        }

        // Handle Medical Certificate with pdfImg2 template
        if (form.type === "medicalCertificate") {
            generateMedicalOriginal(form.data);
            return;
        }

        if (form.type === "accompanyingCertificate") {
            generateMedicalCertificatePDF(form.data);
            return;
        }

        // Handle Health Fitness Certificate
        if (form.type === "healthFitnessCertificate") {
            generateHealthFitnessPDF(form.data);
            return;
        }

        if (form.type === "houseMaidHealthCheckup") {
            houseGenerate(form.data);
            return;
        }

        // Handle Referral Form
        if (form.type === "referral") {
            generateReferralPDF(form.data);
            return;
        }

        const formData = form.data;

        const doc = new jsPDF({
            orientation: "portrait",
            unit: "px",
            format: "a4",
        });

        // Add background image (full page)
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        doc.addImage(pdfImg, "JPEG", 0, 0, pageWidth, pageHeight);

        //  logo sec
        doc.setFillColor(255, 255, 255);
        doc.rect(10, 10, 50, 30, "F");
        const addLogo = (imgData, y) => {
            const imgProps = doc.getImageProperties(imgData);
            const pageWidth = doc.internal.pageSize.getWidth();
            let imgWidth = imgProps.width;
            let imgHeight = imgProps.height;

            // Maximum dimensions
            const maxWidth = pageWidth - 100; // 20px margin each side
            const maxHeight = 30; // fixed max height

            // Calculate ratios
            const widthRatio = maxWidth / imgWidth;
            const heightRatio = maxHeight / imgHeight;
            const ratio = Math.min(widthRatio, heightRatio);

            // Scale image
            const finalWidth = imgWidth * ratio;
            const finalHeight = imgHeight * ratio;

            // Center horizontally
            const centeredX = 20;

            doc.addImage(
                imgData,
                (imgProps.fileType || "PNG").toUpperCase(),
                centeredX,
                10,
                finalWidth,
                finalHeight,
                undefined,
                "NONE"
            );
        };

        try {
            if (
                businessLogo &&
                typeof businessLogo === "string" &&
                businessLogo.startsWith("data:image/") &&
                businessLogo.includes("base64")
            ) {
                addLogo(businessLogo, 20);
            } else {
                throw new Error("Invalid logo format");
            }
        } catch (err) {
            console.warn(err.message);
            addLogo(logo1, 20);
        }
        doc.setFillColor(255, 255, 255);
        doc.rect(86, 63.5, 122, 12, "F");

        doc.setTextColor(0, 0, 0);
        doc.setFontSize(11);
        // Dynamic Patient Name
        doc.setFillColor(255, 255, 255);
        doc.rect(83, 59.5, 150, 20, "F");
        doc.text(formData.patientName || "", 87, 78);

        // Dynamic File Number
        doc.setFillColor(255, 255, 255);
        doc.rect(pageWidth - 120, 59.5, 115, 20, "F");
        doc.text(formData.fileNo?.toString() || "", pageWidth - 115, 78);

        // Dynamic Date
        doc.setFillColor(255, 255, 255);
        doc.rect(55, 81, 130, 20, "F");
        doc.text(formData.date || "", 55, 98);

        // Dynamic CPR Number
        doc.setFillColor(255, 255, 255);
        doc.rect(pageWidth - 120, 81, 130, 20, "F");
        doc.text(formData.cprNo || "", pageWidth - 120, 98);

        // Dynamic Physician
        doc.setFillColor(255, 255, 255);
        doc.rect(68, 102, 130, 18, "F");
        doc.text(formData.physician || "", 73, 118);

        // Dynamic Age/Sex
        doc.setFillColor(255, 255, 255);
        doc.rect(pageWidth - 125, 102, 130, 20, "F");
        doc.text(formData.ageSex || "", pageWidth - 120, 118);
        // bottom - Physician's Recommendation (Dynamic)

        const recommendationText =
            formData.recommendation || "No recommendation provided.";

        const leftMargin = 27;
        const rightMargin = 20;
        const textWidth = pageWidth - leftMargin - rightMargin;

        const lines = doc.splitTextToSize(recommendationText, textWidth);

        const fontSize = 11;
        const lineHeight = 1.9;
        let y = 246;

        doc.setFontSize(fontSize);

        // draw wrapped text with spacing between lines
        lines.forEach((line) => {
            doc.text(line, leftMargin, y);
            y += fontSize * lineHeight;
        });

        // Patient Signature Section
        doc.setFillColor(255, 255, 255);
        doc.rect(25, 512, 130, 17, "F");
        doc.text(formData.patientSignature || "", 28, 527);

        doc.setFillColor(255, 255, 255);
        doc.rect(235, 512, 130, 17, "F");
        doc.text(formData.patientSignatureDate || "", 238, 527);

        // Witness Section
        doc.setFillColor(255, 255, 255);
        doc.rect(30, 554, 150, 12, "F");
        doc.text(formData.witnessSignature || "", 28, 567);

        doc.setFillColor(255, 255, 255);
        doc.rect(239, 551, 130, 20, "F");
        doc.text(formData.witnessSignatureDate || "", 238, 567);
        const pdfBlob = doc.output("bloburl");
        window.open(pdfBlob, "_blank");
    };

    const generateHealthFitnessPDF = (originalFormData) => {
        let formData = { ...originalFormData };

        const doc = new jsPDF({
            orientation: "portrait",
            unit: "mm",
            format: "a4",
        });

        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        doc.addImage(pdfHealth, "JPEG", 0, 0, pageWidth, pageHeight);
        doc.setFillColor(255, 255, 255);
        doc.rect(80, 20, 60, 10, "F");

        const PX_TO_MM = 0.264583;

        const addLogo = (imgData, yMm) => {
            const imgProps = doc.getImageProperties(imgData);
            const pageWidth = doc.internal.pageSize.getWidth();
            let imgWidthMm = imgProps.width * PX_TO_MM;
            let imgHeightMm = imgProps.height * PX_TO_MM;

            const maxWidth = pageWidth - 40;
            const maxHeight = 15;

            const widthRatio = maxWidth / imgWidthMm;
            const heightRatio = maxHeight / imgHeightMm;
            const ratio = Math.min(widthRatio, heightRatio, 1);

            const finalWidth = imgWidthMm * ratio;
            const finalHeight = imgHeightMm * ratio;

            const centeredX = (pageWidth - finalWidth) / 2;

            doc.addImage(
                imgData,
                (imgProps.fileType || "PNG").toUpperCase(),
                centeredX,
                5,
                finalWidth,
                finalHeight
            );
        };
        try {
            if (
                businessLogo &&
                typeof businessLogo === "string" &&
                businessLogo.startsWith("data:image/") &&
                businessLogo.includes("base64")
            ) {
                addLogo(businessLogo, 20);
            } else {
                throw new Error("Invalid logo format");
            }
        } catch (err) {
            console.warn(err.message);
            addLogo(logo1, 10);
        }

        doc.setTextColor(0, 0, 0);
        doc.setFontSize(11);
        let x = 50.7;
        let y = 56;
        const lineGap = 6.2;

        const patientName =
            formData.name ||
            patientData?.firstName + " " + patientData?.lastName ||
            "";
        const cprNumber =
            formData.cprNumber ||
            patientData?.civilIdNumber ||
            patientData?.cpr ||
            "";
        const profession = formData.profession || "";
        const doctorName = formData.performedByName || "";

        const lines = [patientName, cprNumber, profession, doctorName];

        lines.forEach((text, index) => {
            doc.text(String(text), x, y + index * lineGap);
        });

        const hiv1Hiv2 = formData.hiv1Hiv2 || "Negative";
        const hbsag = formData.hbsag || "Negative";
        const hcv = formData.hcv || "Negative";

        doc.text(hiv1Hiv2 === "Positive" ? "Yes" : "No", 50.5, 92);
        doc.text(hbsag === "Positive" ? "Yes" : "No", 50.5, 101);
        doc.text(hcv === "Positive" ? "Yes" : "No", 50.5, 110);

        doc.text(hiv1Hiv2 === "Negative" ? "Yes" : "No", 85, 92);
        doc.text(hbsag === "Negative" ? "Yes" : "No", 85, 101);
        doc.text(hcv === "Negative" ? "Yes" : "No", 85, 110);

        if (formData.bloodPressure) {
            doc.text(String(formData.bloodPressure), 170, 92);
        }

        if (formData.randomBloodSugar) {
            doc.text(String(formData.randomBloodSugar), 170, 101);
        }

        const ppdReading = formData.ppdReading || "";
        const igra = formData.igra || "";
        const chestXray = formData.chestXray || "";
        const chestXrayNegative =
            formData.chestXrayNegative || formData.tbScreeningGuideline || "";

        if (ppdReading) {
            doc.text(String(ppdReading), 62, 130.3);
        }
        if (chestXray) {
            doc.text(String(chestXray), 62, 139.3);
        }

        if (igra) {
            doc.text(String(igra), 131, 130.3);
        }
        if (chestXrayNegative) {
            doc.text(String(chestXrayNegative), 131, 139.3);
        }

        const physicalGeneral = formData.physicalGeneral || "Normal";
        const physicalChest = formData.physicalChest || "Normal";
        const physicalHeart = formData.physicalHeart || "Normal";
        const physicalAbdomen = formData.physicalAbdomen || "Normal";
        const physicalOthers = formData.physicalOthers || "Normal";

        const physicalResults = [
            physicalGeneral === "Normal" ? "Yes" : "No",
            physicalChest === "Normal" ? "Yes" : "No",
            physicalHeart === "Normal" ? "Yes" : "No",
            physicalAbdomen === "Normal" ? "Yes" : "No",
            physicalOthers === "Normal" ? "Yes" : "No",
        ];

        physicalResults.forEach((text, i) => {
            doc.text(text, 62, 160 + i * 6.3);
        });

        const physicalResultsOpposite = [
            physicalGeneral === "Normal" ? "No" : "Yes",
            physicalChest === "Normal" ? "No" : "Yes",
            physicalHeart === "Normal" ? "No" : "Yes",
            physicalAbdomen === "Normal" ? "No" : "Yes",
            physicalOthers === "Normal" ? "No" : "Yes",
        ];

        physicalResultsOpposite.forEach((text, i) => {
            doc.text(text, 131, 160 + i * 6.3);
        });
        doc.setFillColor(255, 255, 255);
        doc.rect(100, 187, 100, 5, "F");
        doc.text(formData.referral || "", 62, 191);

        doc.setFillColor(255, 255, 255);
        doc.rect(5.5, 202.7, 10, 5, "F");

        if (formData.healthDeclaration) {
            const checkboxX1 = 12;
            const checkboxY1 = 202.7;
            const checkboxSize1 = 3;

            doc.setLineWidth(0.5);
            doc.rect(checkboxX1, checkboxY1, checkboxSize1, checkboxSize1);

            doc.setLineWidth(0.5);
            doc.line(checkboxX1 + 0.6, checkboxY1 + 1.5, checkboxX1 + 1.2, checkboxY1 + 2.2);
            doc.line(checkboxX1 + 1.2, checkboxY1 + 2.2, checkboxX1 + 3, checkboxY1 + 0.3);
        }

        if (formData.vaccinationComments) {
            doc.text(String(formData.vaccinationComments), 87, 225.5);
        }

        doc.setFillColor(255, 255, 255);
        doc.rect(5.5, 237, 10, 5, "F");

        if (formData.certificateDeclaration) {
            const checkboxX = 12;
            const checkboxY = 238.5;
            const checkboxSize = 3;

            doc.setLineWidth(0.5);
            doc.rect(checkboxX, checkboxY, checkboxSize, checkboxSize);

            doc.setLineWidth(0.5);
            doc.line(checkboxX + 0.6, checkboxY + 1.5, checkboxX + 1.2, checkboxY + 2.2);
            doc.line(checkboxX + 1.2, checkboxY + 2.2, checkboxX + 3, checkboxY + 0.3);
        }

        const licenseNumber = formData.licenseNumber || "";
        const category = formData.category || "";
        const examinationDate = formData.examinationDate || "";

        const examinerDetails = [
            doctorName,
            licenseNumber,
            category,
            examinationDate,
        ];

        examinerDetails.forEach((text, i) => {
            if (text) {
                doc.text(String(text), 86.5, 257.2 + i * 6.3);
            }
        });

        const pdfBlob = doc.output("bloburl");
        window.open(pdfBlob, "_blank");
    };

    const generateReferralPDF = (originalFormData) => {
        let formData = { ...originalFormData };

        const doc = new jsPDF({
            orientation: "portrait",
            unit: "mm",
            format: "a4",
        });
        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        const PX_TO_MM = 0.264583;

        const addLogo = (imgData, yMm) => {
            const imgProps = doc.getImageProperties(imgData);
            const pageWidth = doc.internal.pageSize.getWidth();
            let imgWidthMm = imgProps.width * PX_TO_MM;
            let imgHeightMm = imgProps.height * PX_TO_MM;

            const maxWidth = pageWidth - 40;
            const maxHeight = 15;

            const widthRatio = maxWidth / imgWidthMm;
            const heightRatio = maxHeight / imgHeightMm;
            const ratio = Math.min(widthRatio, heightRatio, 1);

            const finalWidth = imgWidthMm * ratio;
            const finalHeight = imgHeightMm * ratio;

            const centeredX = (pageWidth - finalWidth) / 2;

            doc.addImage(
                imgData,
                (imgProps.fileType || "PNG").toUpperCase(),
                centeredX,
                5,
                finalWidth,
                finalHeight
            );
        };
        try {
            if (
                businessLogo &&
                typeof businessLogo === "string" &&
                businessLogo.startsWith("data:image/") &&
                businessLogo.includes("base64")
            ) {
                addLogo(businessLogo, 20);
            } else {
                throw new Error("Invalid logo format");
            }
        } catch (err) {
            console.warn(err.message);
            addLogo(logo1, 10);
        }

        doc.setTextColor(0, 0, 0);
        doc.setFontSize(10);

        autoTable(doc, {
            startY: 28,
            theme: "grid",
            head: [],
            body: [
                [
                    { content: "Name of the patient:", styles: { cellPadding: { top: 4, bottom: 4, left: 2, right: 2 }, fontStyle: "bold" } },
                    { content: formData.patientName || patientData?.firstName + " " + patientData?.lastName || "", styles: { cellPadding: { top: 4, bottom: 4, left: 2, right: 2 } } },
                    { content: "CPR:", styles: { cellPadding: { top: 4, bottom: 4, left: 2, right: 2 }, fontStyle: "bold" } },
                    { content: formData.cpr || patientData?.civilIdNumber || "", styles: { cellPadding: { top: 4, bottom: 4, left: 2, right: 2 } } },
                ],
                [
                    { content: "Age:", styles: { fontStyle: "bold" } },
                    { content: formData.age || patientData?.age || "" },
                    { content: "Nationality:", styles: { fontStyle: "bold" } },
                    { content: formData.nationality || patientData?.nationality || "" },
                ],
                [
                    { content: "Sex:", styles: { fontStyle: "bold" } },
                    { content: formData.sex || patientData?.gender || "" },
                    { content: "Phone No:", styles: { fontStyle: "bold" } },
                    { content: formData.mobileNumber || formData.phoneNo || patientData?.mobileNumber || "" },
                ],
            ],
            styles: { fontSize: 10, cellPadding: { top: 1, bottom: 1, left: 2, right: 2 }, lineColor: [0, 0, 0], textColor: [0, 0, 0], lineWidth: 0.1 },
            columnStyles: { 0: { minCellWidth: 30 }, 1: { minCellWidth: 35 }, 2: { minCellWidth: 20 }, 3: { minCellWidth: 35 } },
            tableWidth: "auto",
            margin: { left: 10, right: 10 },
        });

        const tableY = doc.lastAutoTable.finalY;
        doc.setFont("helvetica", "bold");
        doc.text("Referral Type:", 9, tableY + 7);
        doc.setFont("helvetica", "normal");

        const gap = 3.5;

        function drawCheckboxWithLabel(doc, x, y, label, isChecked) {
            const boxSize = 3.5;
            const newY = y + 4;
            doc.setLineWidth(0.4);
            doc.rect(x, newY, boxSize, boxSize);
            if (isChecked) {
                doc.line(x + 0.5, newY + 2.0, x + 1.4, newY + 3.0);
                doc.line(x + 1.4, newY + 3.0, x + 2.8, newY + 1.0);
            }
            doc.text(label, x + boxSize + 3, newY + 2.8);
        }

        drawCheckboxWithLabel(doc, 10, tableY + 6, "Internal", formData.referralType === "internal");
        drawCheckboxWithLabel(doc, 10, tableY + 6 + gap + 3.5, "External", formData.referralType === "external");

        doc.setFont("helvetica", "bold");
        doc.text("Referral Category:", 45, tableY + 7);
        doc.setFont("helvetica", "normal");

        function drawRightCheckbox(doc, posX, posY, labelText, isChecked) {
            const boxSize = 3.5;
            const newY = posY + 4;
            doc.setLineWidth(0.4);
            doc.rect(posX, newY, boxSize, boxSize);
            if (isChecked) {
                doc.line(posX + 0.5, newY + 2.0, posX + 1.4, newY + 3.0);
                doc.line(posX + 1.4, newY + 3.0, posX + 2.8, newY + 1.0);
            }
            doc.text(labelText, posX + boxSize + 3, newY + 2.8);
        }

        drawRightCheckbox(doc, 50, tableY + 6, "Urgent", formData.referralCategory === "urgent");
        drawRightCheckbox(doc, 50, tableY + 6 + gap + 3.5, "Routine", formData.referralCategory === "routine");

        doc.setFont("helvetica", "bold");
        doc.text("Reason of referral:", 88, tableY + 7);
        doc.setFont("helvetica", "normal");
        const reasonContent = formData.reasonOfReferral || "";
        const wrapped = doc.splitTextToSize(reasonContent, 111.8 - 4);
        const rectHeight = Math.max(8, wrapped.length * 6);
        doc.setLineWidth(0.1);
        doc.rect(88, tableY + 10, 111.8, rectHeight);
        doc.text(wrapped, 88 + 4, tableY + 10 + 4);

        doc.setFont("helvetica", "bold");
        doc.text("History:", 10, tableY + 28);
        doc.setFont("helvetica", "normal");

        autoTable(doc, {
            startY: tableY + 32,
            theme: "grid",
            head: [],
            body: [
                [{ content: "chief complain:", styles: { fontStyle: "bold" } }, { content: formData.chiefComplain || "" }],
                [{ content: "Summary of presentation:", styles: { fontStyle: "bold" } }, { content: formData.summaryOfPresentation || "" }],
            ],
            styles: { fontSize: 10, cellPadding: { top: 1, bottom: 1, left: 2, right: 2 }, lineColor: [0, 0, 0], textColor: [0, 0, 0], lineWidth: 0.1 },
            columnStyles: { 0: { minCellWidth: 65 } },
            tableWidth: "auto",
            margin: { left: 10, right: 10 },
        });

        const tableY1 = doc.lastAutoTable.finalY;
        doc.setFont("helvetica", "bold");
        doc.text("Physical examination:", 10, tableY1 + 6);
        doc.setFont("helvetica", "normal");
        doc.text("Vital signs :", 10, tableY1 + 12);

        autoTable(doc, {
            startY: tableY1 + 16,
            theme: "grid",
            head: [],
            body: [
                [{ content: "BP", styles: { fontStyle: "bold" } }, { content: formData.vitalSigns?.bp || "" }, { content: "RR", styles: { fontStyle: "bold" } }, { content: formData.vitalSigns?.respiratoryRate || "" }],
                [{ content: "Temperature", styles: { fontStyle: "bold" } }, { content: formData.vitalSigns?.temperature || "" }, { content: "Spo2", styles: { fontStyle: "bold" } }, { content: formData.vitalSigns?.spo2 || "" }],
                [{ content: "RBS", styles: { fontStyle: "bold" } }, { content: formData.vitalSigns?.rbs || "" }, { content: "Weight", styles: { fontStyle: "bold" } }, { content: formData.vitalSigns?.weight || "" }],
                [{ content: "Pulse", styles: { fontStyle: "bold" } }, { content: formData.vitalSigns?.pulse || "", colSpan: 3 }],
            ],
            styles: { fontSize: 10, cellPadding: { top: 1, bottom: 1, left: 2, right: 2 }, lineColor: [0, 0, 0], textColor: [0, 0, 0], lineWidth: 0.1 },
            columnStyles: { 0: { cellWidth: 47.5 }, 1: { cellWidth: 47.5 }, 2: { cellWidth: 47.5 }, 3: { cellWidth: 47.5 } },
            tableWidth: "auto",
            margin: { left: 10, right: 10 },
        });

        const tableY2 = doc.lastAutoTable.finalY;
        doc.text("Glascow coma scale", 10, tableY2 + 6);

        autoTable(doc, {
            startY: tableY2 + 10,
            theme: "grid",
            head: [],
            body: [
                [{ content: "Eye", styles: { fontStyle: "bold" } }, { content: formData.glasgowComaScale?.eye || "" }, { content: "Motor response", styles: { fontStyle: "bold" } }, { content: formData.glasgowComaScale?.motorResponse || "" }],
                [{ content: "Verbal response", styles: { fontStyle: "bold" } }, { content: formData.glasgowComaScale?.verbalResponse || "" }, { content: "Total score (out of 15)", styles: { fontStyle: "bold" } }, { content: formData.glasgowComaScale?.totalScore || "" }],
            ],
            styles: { fontSize: 10, cellPadding: { top: 1, bottom: 1, left: 2, right: 2 }, lineColor: [0, 0, 0], textColor: [0, 0, 0], lineWidth: 0.1 },
            columnStyles: { 0: { cellWidth: 47.5 }, 1: { cellWidth: 47.5 }, 2: { cellWidth: 47.5 }, 3: { cellWidth: 47.5 } },
            tableWidth: "auto",
            margin: { left: 10, right: 10 },
        });

        const tableY3 = doc.lastAutoTable.finalY;

        autoTable(doc, {
            startY: tableY3 + 6,
            theme: "grid",
            head: [],
            body: [
                [{ content: "General examination :", styles: { fontStyle: "bold" } }, { content: formData.generalExamination || "" }],
                [{ content: "Local examination :", styles: { fontStyle: "bold" } }, { content: formData.localExamination || "" }],
                [{ content: "Investigations done :", styles: { fontStyle: "bold" } }, { content: formData.investigationsDone || "" }],
                [{ content: "Procedure & interventions provided :", styles: { fontStyle: "bold" } }, { content: formData.procedureInterventions || "" }],
                [{ content: "Injections & medications given :", styles: { fontStyle: "bold" } }, { content: formData.injectionsMedications || "" }],
                [{ content: "Prescription given to the patient :", styles: { fontStyle: "bold" } }, { content: formData.prescriptionGiven || "" }],
                [{ content: "Notes :", styles: { fontStyle: "bold" } }, { content: formData.notes || "" }],
                [{ content: "Advices :", styles: { fontStyle: "bold" } }, { content: formData.advices || "" }],
            ],
            styles: { fontSize: 10, cellPadding: { top: 1, bottom: 1, left: 2, right: 2 }, lineColor: [0, 0, 0], textColor: [0, 0, 0], lineWidth: 0.1 },
            tableWidth: "auto",
            margin: { left: 10, right: 10 },
        });

        const tableY4 = doc.lastAutoTable.finalY;
        doc.text("Referring doctor", 10, tableY4 + 6);

        autoTable(doc, {
            startY: tableY4 + 10,
            theme: "grid",
            head: [],
            body: [
                [{ content: "Name ", styles: { fontStyle: "bold" } }, { content: "date", styles: { fontStyle: "bold" } }, { content: "time", styles: { fontStyle: "bold" } }, { content: "Phone number ", styles: { fontStyle: "bold" } }],
                [{ content: formData.referringDoctor?.name || "" }, { content: formData.referringDoctor?.date || "" }, { content: formData.referringDoctor?.time || "" }, { content: formData.referringDoctor?.phoneNumber || "" }],
                [{ content: "Sign & seal", colSpan: 4, styles: { fontStyle: "bold", minCellHeight: 25 } }],
            ],
            styles: { fontSize: 10, cellPadding: { top: 1, bottom: 1, left: 2, right: 2 }, lineColor: [0, 0, 0], textColor: [0, 0, 0], lineWidth: 0.1 },
            columnStyles: { 0: { cellWidth: 47.5 }, 1: { cellWidth: 47.5 }, 2: { cellWidth: 47.5 }, 3: { cellWidth: 47.5 } },
            tableWidth: "auto",
            margin: { left: 10, right: 10 },
        });

        const tableY5 = doc.lastAutoTable.finalY;
        doc.text("Receiving doctor", 10, tableY5 + 10);

        autoTable(doc, {
            startY: tableY5 + 35,
            theme: "grid",
            head: [],
            body: [
                [{ content: "Name ", styles: { fontStyle: "bold" } }, { content: "date", styles: { fontStyle: "bold" } }, { content: "time", styles: { fontStyle: "bold" } }, { content: "Phone number ", styles: { fontStyle: "bold" } }],
                [{ content: formData.receivingDoctor?.name || "" }, { content: formData.receivingDoctor?.date || "" }, { content: formData.receivingDoctor?.time || "" }, { content: formData.receivingDoctor?.phoneNumber || "" }],
                [{ content: "Sign & seal", colSpan: 4, styles: { fontStyle: "bold", minCellHeight: 25 } }],
            ],
            styles: { fontSize: 10, cellPadding: { top: 1, bottom: 1, left: 2, right: 2 }, lineColor: [0, 0, 0], textColor: [0, 0, 0], lineWidth: 0.1 },
            columnStyles: { 0: { cellWidth: 47.5 }, 1: { cellWidth: 47.5 }, 2: { cellWidth: 47.5 }, 3: { cellWidth: 47.5 } },
            margin: { left: 10, right: 10 },
            tableWidth: "auto",
            didDrawCell: function (data) {
                if (data.section === "body" && data.row.index === 1) {
                    data.cell.styles.lineBottomWidth = 0;
                }
            },
        });

        const pdfBlob = doc.output("bloburl");
        window.open(pdfBlob, "_blank");
    };
    const generateMedicalOriginal = (formData) => {
        const doc = new jsPDF({
            orientation: "portrait",
            unit: "px",
            format: "a4",
        });
        doc.addFileToVFS("Tajawal-Bold.ttf", tajawalFontBase64);
        doc.addFont("Tajawal-Bold.ttf", "Tajawal", "bold");

        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        doc.addImage(originalMedical, "png", 0, 0, pageWidth, pageHeight);

        const addLogo = (imgData, y) => {
            const imgProps = doc.getImageProperties(imgData);
            const pageWidth = doc.internal.pageSize.getWidth();
            let imgWidth = imgProps.width;
            let imgHeight = imgProps.height;

            const maxWidth = pageWidth - 40;
            const maxHeight = 30;

            const widthRatio = maxWidth / imgWidth;
            const heightRatio = maxHeight / imgHeight;
            const ratio = Math.min(widthRatio, heightRatio);

            const finalWidth = imgWidth * ratio;
            const finalHeight = imgHeight * ratio;

            const centeredX = (pageWidth - finalWidth) / 2;

            doc.addImage(
                imgData,
                (imgProps.fileType || "PNG").toUpperCase(),
                centeredX,
                40,
                finalWidth,
                finalHeight,
                undefined,
                "NONE"
            );
        };

        try {
            if (
                businessLogo &&
                typeof businessLogo === "string" &&
                businessLogo.startsWith("data:image/") &&
                businessLogo.includes("base64")
            ) {
                addLogo(businessLogo, 20);
            } else {
                throw new Error("Invalid logo format");
            }
        } catch (err) {
            console.warn(err.message);
            addLogo(logo1, 20);
        }

        doc.setFontSize(12);
        doc.setFont("helvetica", "bold");
        doc.setTextColor(43, 43, 46);

        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        doc.text(formData.patientName || "", 155, 160);
        doc.text(formData.cprNumber || "", 155, 182);
        doc.text(formData.medicalRecordNumber?.toString() || "", 155, 197);

        doc.setDrawColor(156, 194, 229);
        doc.setLineWidth(1);
        const checkX = 147.5;
        const checkStartY = 220;
        const checkGapY = 20;
        doc.setFontSize(10);
        const checkboxValues = [
            formData.reportedSick,
            formData.accompanyingPatient,
        ];

        for (let index = 0; index < checkboxValues.length; index++) {
            if (checkboxValues[index]) {
                const currentY = checkStartY + index * checkGapY;

                doc.line(checkX - 3, currentY, checkX, currentY + 3);
                doc.line(checkX, currentY + 3, checkX + 5, currentY - 3);
            }
        }

        function drawVerticalTicks() {
            const checkboxStates = [
                formData.patientFitForDuty,
                formData.patientUnfitForDuty,
                formData.advisedLightDuty,
                formData.patientNeedsEmployeeCare,
            ];

            const tickX = 310;
            const startY = 224;
            const rowGaps = [21, 23, 25];

            doc.setFontSize(10);

            let currentY = startY;

            for (let index = 0; index < checkboxStates.length; index++) {
                if (checkboxStates[index]) {
                    doc.line(tickX - 3, currentY, tickX, currentY + 3);
                    doc.line(tickX, currentY + 3, tickX + 5, currentY - 3);
                }

                if (rowGaps[index]) {
                    currentY += rowGaps[index];
                }
            }
        }

        drawVerticalTicks();

        if (formData.timeOfAttend) {
            doc.setFontSize(10);
            doc.text(formData.timeOfAttend, 142, 263);
        }
        if (formData.timeOfConsult) {
            doc.setFontSize(10);
            doc.text(formData.timeOfConsult, 142, 286);
        }
        if (formData.consultDate) {
            doc.setFontSize(10);
            doc.text(formData.consultDate, 142, 309);
        }

        const daysOffTexts = [
            formData.noOfDaysOffFigures || "",
            formData.noOfDaysOffWords || "",
            formData.commencingOn || "",
        ];
        const baseX = 170;
        let baseY = 339;
        const yGap = 15;
        doc.setFontSize(10);
        daysOffTexts.forEach((text, i) => {
            doc.text(text, baseX, baseY + i * yGap);
        });

        if (formData.diagnosis) {
            doc.setFontSize(10);
            const diagnosisLines = doc.splitTextToSize(formData.diagnosis, 250);
            let diagY = 399;
            diagnosisLines.slice(0, 2).forEach((line) => {
                doc.text(line, 105, diagY);
                diagY += 10;
            });
        }

        const admissionTexts = [
            formData.admittedOn || "",
            formData.dischargedOn || "",
        ];
        const baseX1 = 183;
        let baseY11 = 426;
        const yGap1 = 12;
        doc.setFontSize(10);
        admissionTexts.forEach((text, i) => {
            doc.text(text, baseX1, baseY11 + i * yGap1);
        });

        const doctorTexts = [
            formData.doctorName || "",
            formData.licenseNo || "",
            formData.specialty || "",
            formData.issueDate || "",
        ];
        const baseX2 = 183;
        let baseY12 = 463;
        const yGap2 = 12;
        doc.setFontSize(10);
        doctorTexts.forEach((text, i) => {
            doc.text(text, baseX2, baseY12 + i * yGap2);
        });

        doc.setFont("helvetica", "bold");
        doc.setFontSize(12);
        doc.text(businessPhone || "", 163, 591);
        doc.text(businessEmail || "", 221, 591);
        doc.text(businessAddress || "", 143, 604);

        const pdfBlob = doc.output("bloburl");
        window.open(pdfBlob, "_blank");
    };

    const generateMedicalCertificatePDF = (formData) => {
        const doc = new jsPDF({
            orientation: "portrait",
            unit: "px",
            format: "a4",
        });
        doc.addFileToVFS("Tajawal-Bold.ttf", tajawalFontBase64);
        doc.addFont("Tajawal-Bold.ttf", "Tajawal", "bold");

        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        doc.addImage(pdfimg3, "JPEG", 0, 0, pageWidth, pageHeight);

        const addLogo = (imgData, y) => {
            const imgProps = doc.getImageProperties(imgData);
            const pageWidth = doc.internal.pageSize.getWidth();
            let imgWidth = imgProps.width;
            let imgHeight = imgProps.height;

            const maxWidth = pageWidth - 40;
            const maxHeight = 30;

            const widthRatio = maxWidth / imgWidth;
            const heightRatio = maxHeight / imgHeight;
            const ratio = Math.min(widthRatio, heightRatio);

            const finalWidth = imgWidth * ratio;
            const finalHeight = imgHeight * ratio;

            const centeredX = (pageWidth - finalWidth) / 2;

            doc.addImage(
                imgData,
                (imgProps.fileType || "PNG").toUpperCase(),
                centeredX,
                20,
                finalWidth,
                finalHeight,
                undefined,
                "NONE"
            );
        };

        try {
            if (
                businessLogo &&
                typeof businessLogo === "string" &&
                businessLogo.startsWith("data:image/") &&
                businessLogo.includes("base64")
            ) {
                addLogo(businessLogo, 20);
            } else {
                throw new Error("Invalid logo format");
            }
        } catch (err) {
            console.warn(err.message);
            addLogo(logo1, 20);
        }

        doc.setFontSize(10);
        doc.setFont("helvetica", "normal");
        doc.text(formData.patientName || "", 155, 140);
        doc.text(formData.cprNumber || "", 155, 160);

        if (formData.accompanyingPatient) {
            doc.text(formData.accompanyingPersonName || "", 155, 202);
            doc.text(formData.accompanyingPersonId || "", 155, 224);
        }
        doc.text(formData.medicalRecordNumber?.toString() || "", 155, 240);

        if (formData.timeOfAttend) {
            doc.setFontSize(10);
            doc.text(formData.timeOfAttend, 142, 305);
        }
        if (formData.timeOfConsult) {
            doc.setFontSize(10);
            doc.text(formData.timeOfConsult, 142, 330);
        }
        if (formData.consultDate) {
            doc.setFontSize(10);
            doc.text(formData.consultDate, 142, 350);
        }

        doc.setDrawColor(156, 194, 229);
        doc.setLineWidth(1);
        const checkX = 147.5;
        const checkStartY = 263;
        const checkGapY = 20;
        doc.setFontSize(10);
        const checkboxValues = [
            formData.reportedSick,
            formData.accompanyingPatient,
        ];

        for (let index = 0; index < checkboxValues.length; index++) {
            if (checkboxValues[index]) {
                const currentY = checkStartY + index * checkGapY;

                doc.line(checkX - 3, currentY, checkX, currentY + 3);
                doc.line(checkX, currentY + 3, checkX + 5, currentY - 3);
            }
        }

        function drawVerticalTicks() {
            const checkboxStates = [
                formData.patientFitForDuty,
                formData.patientUnfitForDuty,
                formData.advisedLightDuty,
                formData.patientNeedsEmployeeCare,
            ];

            const tickX = 310;
            const startY = 267;
            const rowGaps = [20, 24, 26];

            doc.setFontSize(10);

            let currentY = startY;

            for (let index = 0; index < checkboxStates.length; index++) {
                if (checkboxStates[index]) {
                    doc.line(tickX - 3, currentY, tickX, currentY + 3);
                    doc.line(tickX, currentY + 3, tickX + 5, currentY - 3);
                }

                if (rowGaps[index]) {
                    currentY += rowGaps[index];
                }
            }
        }

        drawVerticalTicks();

        const daysOffTexts = [
            formData.noOfDaysOffFigures || "",
            formData.noOfDaysOffWords || "",
            formData.commencingOn || "",
        ];
        const baseX = 170;
        let baseY = 381;
        const yGap = 15;
        doc.setFontSize(10);
        daysOffTexts.forEach((text, i) => {
            doc.text(text, baseX, baseY + i * yGap);
        });

        const admissionTexts = [
            formData.admittedOn || "",
            formData.dischargedOn || "",
        ];
        const baseX1 = 183;
        let baseY11 = 460;
        const yGap1 = 12;
        doc.setFontSize(10);
        admissionTexts.forEach((text, i) => {
            doc.text(text, baseX1, baseY11 + i * yGap1);
        });

        const doctorTexts = [
            formData.doctorName || "",
            formData.licenseNo || "",
            formData.specialty || "",
            formData.issueDate || "",
        ];
        const baseX2 = 183;
        let baseY12 = 492;
        const yGap2 = 12;
        doc.setFontSize(10);
        doctorTexts.forEach((text, i) => {
            doc.text(text, baseX2, baseY12 + i * yGap2);
        });

        if (formData.diagnosis) {
            doc.setFontSize(10);
            const diagnosisLines = doc.splitTextToSize(formData.diagnosis, 250);
            let diagY = 436;
            diagnosisLines.slice(0, 2).forEach((line) => {
                doc.text(line, 105, diagY);
                diagY += 12;
            });
        }

        doc.setFont("helvetica", "bold");
        doc.setFontSize(12);
        doc.text(businessPhone || "", 163, 591);
        doc.text(businessEmail || "", 221, 591);
        doc.text(businessAddress || "", 143, 604);

        const pdfBlob = doc.output("bloburl");
        window.open(pdfBlob, "_blank");
    };

    const houseGenerate = (formData) => {
        const doc = new jsPDF({
            orientation: "portrait",
            unit: "mm",
            format: "a4",
        });

        const pageWidth = doc.internal.pageSize.getWidth();
        const pageHeight = doc.internal.pageSize.getHeight();

        doc.addImage(pdfHouse, "JPEG", 0, 0, pageWidth, pageHeight);

        const PX_TO_MM = 0.264583;

        const addLogo = (imgData) => {
            const imgProps = doc.getImageProperties(imgData);
            const pageWidth = doc.internal.pageSize.getWidth();
            let imgWidthMm = imgProps.width * PX_TO_MM;
            let imgHeightMm = imgProps.height * PX_TO_MM;

            const maxWidth = pageWidth - 40;
            const maxHeight = 15;

            const widthRatio = maxWidth / imgWidthMm;
            const heightRatio = maxHeight / imgHeightMm;
            const ratio = Math.min(widthRatio, heightRatio, 1);

            const finalWidth = imgWidthMm * ratio;
            const finalHeight = imgHeightMm * ratio;

            const centeredX = (pageWidth - finalWidth) / 2;
            doc.setFillColor(255, 255, 255);
            doc.rect(65, 7, 80, 20, "F");
            doc.addImage(
                imgData,
                (imgProps.fileType || "PNG").toUpperCase(),
                centeredX,
                5,
                finalWidth,
                finalHeight
            );
        };

        try {
            if (
                businessLogo &&
                typeof businessLogo === "string" &&
                businessLogo.startsWith("data:image/") &&
                businessLogo.includes("base64")
            ) {
                addLogo(businessLogo);
            } else {
                addLogo(logo1);
            }
        } catch (err) {
            addLogo(logo1);
        }

        doc.setTextColor(0, 0, 0);
        doc.setFontSize(10);

        doc.text(String(formData.patientName || ""), 37, 31.2);
        doc.text(String(formData.civilId || ""), 30, 36.7);
        doc.text(String(formData.mobileNumber || ""), 67, 36.7);

        doc.setFillColor(255, 255, 255);
        doc.rect(148, 33, 10, 5, "F");
        doc.text("CPR#:", 148, 36.5);

        doc.text(
            String(formData.heightCm || formData.height || ""),
            109,
            36.7
        );
        doc.text(String(formData.doctorName || ""), 118, 42);
        doc.text(String(formData.examinerLicense || ""), 160, 31.2);

        doc.text(String(formData.bloodPressure || ""), 15, 73);
        doc.text(String(formData.pulse || ""), 60, 73);
        doc.text(String(formData.heightCm || ""), 89, 73);
        doc.text(String(formData.weight || ""), 129, 73);
        doc.text(String(formData.bmi || ""), 180, 73);

        doc.text(String(formData.rightEyeStatus || ""), 111, 95.7);
        doc.text(String(formData.leftEyeStatus || ""), 111, 101.5);
        doc.text(String(formData.colorVisionStatus || ""), 111, 106.9);
        doc.text(String(formData.eyeComment || ""), 60, 114);

        doc.text(String(formData.rightEarStatus || ""), 91, 124.5);
        doc.text(String(formData.leftEarStatus || ""), 91, 130);
        doc.text(String(formData.earComment || ""), 60, 136.5);

        doc.text(String(formData.heartStatus || ""), 101, 146.5);
        doc.text(String(formData.heartComment || ""), 60, 151.8);

        doc.text(String(formData.lungsStatus || ""), 101, 161.8);
        doc.text(String(formData.lungsComment || ""), 60, 167);

        doc.text(String(formData.abdomenStatus || ""), 101, 177.3);
        doc.text(String(formData.abdomenComment || ""), 60, 182.5);

        doc.text(String(formData.urineRoutineStatus || ""), 101, 203.2);
        doc.text(String(formData.urineRoutineComment || ""), 60, 208.5);

        doc.text(String(formData.cbcHbStatus || ""), 101, 218.8);
        doc.text(String(formData.cbcHbComment || ""), 60, 224);

        doc.text(String(formData.vdlHivHcvStatus || ""), 101, 234.3);
        doc.text(String(formData.vdlHivHcvComment || ""), 60, 239.5);

        doc.text(String(formData.chestXrayStatus || ""), 101, 249.4);
        doc.text(String(formData.chestXrayComment || ""), 60, 254.6);

        doc.text(String(formData.treatmentRequired || "NO"), 45, 262);

        doc.text(String(formData.doctorName || ""), 25, 277);

        doc.text(String(formData.examinerSpecialty || ""), 15, 279);
        doc.text(String(formData.examinationDate || ""), 115, 274);

        const pdfBlob = doc.output("bloburl");
        window.open(pdfBlob, "_blank");
    };

    const handlePrintForm = (form) => {
        generateForm(form);
    };

    if (loading) return <div className="p-4 text-center">Loading forms...</div>;

    return (
        <div className="portal-module-container patientCommonCon">
            <div className="row">
                <div className="col-12">
                    <div className="table-card">
                        <div className="tableHeader d-flex justify-content-between align-items-center">
                            <h5 className="mb-0">My Forms & Certificates</h5>
                        </div>
                        <div>
                            {forms.length === 0 ? (
                                <div className="text-center py-5">
                                    <p className="text-muted">No forms available</p>
                                </div>
                            ) : (
                                <>
                                    <div className="table-responsive">
                                        <table className="table">
                                            <thead>
                                                <tr>
                                                    <th>Form Type</th>
                                                    {/* <th>Patient Name</th> */}
                                                    <th>Created Date</th>
                                                    <th className="text-center">Actions</th>
                                                </tr>
                                            </thead>
                                            <tbody>
                                                {(() => {
                                                    const totalPages =
                                                        Math.ceil(forms.length / formsPerPage) || 1;
                                                    const paginatedForms = forms.slice(
                                                        (currentPage - 1) * formsPerPage,
                                                        currentPage * formsPerPage
                                                    );
                                                    return paginatedForms.map((form) => (
                                                        <tr key={form.id}>
                                                            <td>
                                                                {form.type === "ama"
                                                                    ? "Against Medical Advice"
                                                                    : form.type === "medicalCertificate"
                                                                        ? "Medical Certificate"
                                                                        : form.type === "accompanyingCertificate"
                                                                            ? "Accompanying Certificate"
                                                                            : form.type === "referral"
                                                                                ? "Referral Form"
                                                                                : form.type === "healthFitnessCertificate"
                                                                                    ? "Health Fitness Certificate"
                                                                                    : form.type === "houseMaidHealthCheckup"
                                                                                        ? "House Maid Health Checkup"
                                                                                        : "Unknown Form"}
                                                            </td>
                                                            {/* <td>{form.data.patientName}</td> */}
                                                            <td>
                                                                {new Date(form.createdAt).toLocaleDateString()}
                                                            </td>
                                                            <td className="text-center">
                                                                <button
                                                                    className="btn btn-sm deleteIcon"
                                                                    onClick={() => handlePrintForm(form)}
                                                                    title="Print PDF"
                                                                >
                                                                    <i className="ti ti-printer f-20" />
                                                                    <span>Print</span>
                                                                </button>
                                                            </td>
                                                        </tr>
                                                    ));
                                                })()}
                                            </tbody>
                                        </table>
                                    </div>
                                    {Math.ceil(forms.length / formsPerPage) > 1 && (
                                        <nav className="tablepagination d-flex justify-content-end mt-3 mb-2">
                                            <ul className="pagination mb-0">
                                                <li
                                                    className={`page-item ${currentPage === 1 ? "disabled" : ""
                                                        }`}
                                                >
                                                    <button
                                                        className="page-link"
                                                        onClick={() =>
                                                            currentPage > 1 && setCurrentPage(currentPage - 1)
                                                        }
                                                    >
                                                        &laquo;
                                                    </button>
                                                </li>
                                                <li className="pageNmbr">{`${currentPage} of ${Math.ceil(
                                                    forms.length / formsPerPage
                                                )}`}</li>
                                                <li
                                                    className={`page-item ${currentPage ===
                                                        Math.ceil(forms.length / formsPerPage)
                                                        ? "disabled"
                                                        : ""
                                                        }`}
                                                >
                                                    <button
                                                        className="page-link"
                                                        onClick={() =>
                                                            currentPage <
                                                            Math.ceil(forms.length / formsPerPage) &&
                                                            setCurrentPage(currentPage + 1)
                                                        }
                                                    >
                                                        &raquo;
                                                    </button>
                                                </li>
                                            </ul>
                                        </nav>
                                    )}
                                </>
                            )}
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
